import { h } from 'preact';

import { WCAGSummarySkeleton } from 'components/wcag-summary/wcag-summary-skeleton';
import { COMPONENT_NAME_MANAGE_SKELETON } from './constants';
import type { ManageSkeletonProps } from './types';

import './manage-skeleton.scss';

export const ManageSkeleton = (props: ManageSkeletonProps) => {
  const { withWCAGSummary, skeletonItems = 4 } = props;
  return (
    <div className="uwaw-manage-skeleton__nav" data-testid={COMPONENT_NAME_MANAGE_SKELETON}>
      {withWCAGSummary && <WCAGSummarySkeleton />}

      {Array.from({ length: skeletonItems }).map((_, idx) => (
        <div
          key={`skeletonItem-${idx}`}
          className="uwaw-manage-skeleton__nav-item"
          data-testid={`${COMPONENT_NAME_MANAGE_SKELETON}-item`}
        >
          <div className="uwaw-manage-skeleton__nav-icon" />
          <div className="uwaw-manage-skeleton__nav-label" />
        </div>
      ))}
      <div className="uwaw-manage-skeleton__nav-block">
        <div className="uwaw-manage-skeleton__nav-block-title">
          <div className="uwaw-manage-skeleton__nav-icon" />
          <div className="uwaw-manage-skeleton__nav-label" />
        </div>
        <div className="uwaw-manage-skeleton__nav-block-content">
          <div className="uwaw-manage-skeleton__nav-label" />
          <div className="uwaw-manage-skeleton__nav-label" />
        </div>
        <div className="uwaw-manage-skeleton__nav-button" />
      </div>
    </div>
  );
};

ManageSkeleton.displayName = COMPONENT_NAME_MANAGE_SKELETON;
